import type React from 'react';
import { useDispatch } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

import Container from 'app/shared/core/Container';
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import Linker from 'app/shared/modules/Linker';
import RouteActions from 'app/shared/flux/actions/RouteActions';
import Row from 'app/shared/core/Row';
import Text from 'app/shared/core/Text';
import type { ListingDetails } from 'app/types/listingDetails.type';

interface LinkToBuildingProps {
  listing: ListingDetails;
}

interface BuildingInfo {
  renderLink: boolean | string;
  count?: number;
}

const LinkToBuilding: React.FC<LinkToBuildingProps> = ({ listing }) => {
  const dispatch = useDispatch();

  const yieldTransitionTo = useYieldCallback(() => {
    dispatch(
      RouteActions.transitionToListing({
        listingUri: listing.uriBuilding,
        keepMapLocation: true,
        filter: null,
      }),
    );
  });

  const handleTransitionToBuildingPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    yieldTransitionTo();
  };

  const getBuildingInfo = (): BuildingInfo => {
    if (listing?.forRentUnitsInBuilding?.length > 1) {
      return {
        renderLink: 'rental',
        count: listing.forRentUnitsInBuilding.length - 1,
      };
    } else {
      return {
        renderLink: false,
      };
    }
  };

  const getLinkString = (buildingInfo: BuildingInfo): string => {
    const count = buildingInfo.count || 0;
    const unitString = count === 1 ? 'unit' : 'units';
    return `${count} other rental ${unitString} in this building`;
  };

  const buildingInfo = getBuildingInfo();

  if (buildingInfo.renderLink === false) {
    return null;
  }

  return (
    <div>
      <HdpContentWrapper fullContent active>
        <Container>
          <Row>
            <Text responsive={{ smAndUp: 'sm', xlAndUp: 'md' }}>
              <Linker to={listing.uriBuilding} onClick={handleTransitionToBuildingPage}>
                {getLinkString(buildingInfo)}
              </Linker>
            </Text>
          </Row>
        </Container>
      </HdpContentWrapper>
    </div>
  );
};

export default LinkToBuilding;
